module.exports = __webpack_public_path__ + "1d9d7eed34708773da9cdfceffee0a41.pdf";